import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography, Divider, Box, AppBar, Toolbar, IconButton } from '@mui/material';
import Link from '@mui/material/Link';
import { Close, Print } from '@mui/icons-material';
import { useContext, useRef, useState } from 'react';
import navbar_background from '../assets/navbar_background.svg';
import { useReactToPrint } from 'react-to-print';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import icon from '../assets/quanto_custa_logo.png';
import mpmg from '../assets/mpmg.png';
import gsi from '../assets/gsi.png';
import LogoCeat from "../assets/logo-ceat-branco.png";
import { Link as RouterLink } from 'react-router-dom';

type Props = {
    open: boolean,
    onClose: (() => void),
    info: any
}

function InfoOverpriceDialog({ open, onClose, info }: Props) {
    const { descriptionOverprice } = useContext(GlobalStateContext);
    const componentRef = useRef<HTMLDivElement>(null);

    const primeiraLetraMaiuscula = (texto: string) => {
        return texto?.charAt(0).toUpperCase() + texto?.slice(1);
    };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: descriptionOverprice || "detalhamento",
        onAfterPrint: () => { }
    });

    const renderPrintContent = () => (
        <div ref={componentRef} className="print-content">
            <AppBar position="static" color="primary" sx={{ backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
                <Toolbar sx={{ justifyContent: 'space-between' }}>
                    <Typography variant='h6'>
                        <RouterLink className='flex flex-1' to="/"><img src={icon} style={{ height: "60px" }} /></RouterLink>
                    </Typography>
                    <div className="flex flex-row mr-0">
                        <img src={mpmg} style={{ height: "45px" }} />
                        <img src={gsi} style={{ height: "45px" }} />
                        <img src={LogoCeat} style={{ height: "45px" }} />
                    </div>
                </Toolbar>
            </AppBar>
            <Box sx={{ padding: 2 }}>
                <Typography variant="h4" textAlign='center' color="initial" sx={{ mb: 2 }}>
                    {primeiraLetraMaiuscula(info?.cp_original.toLowerCase())}
                </Typography>
                {info.id_licitacao && (
                    <p><strong>Id documento:</strong> {info.id_licitacao?.substr(0, 1) === 'M' || info.id_licitacao?.substr(0, 1) === 'E'
                        ? <Link href={`${process.env.REACT_APP_TRILHAS_LICITACOES_URL}/licitacao/${info.id_licitacao}`} target='_blank'>{info.id_licitacao}</Link>
                        : info.id_licitacao}
                    </p>
                )}
                {info.periodo && <p className='mt-2'><strong>Período:</strong> {info.periodo}</p>}
                {info.municipio && <p className='mt-2'><strong>Município:</strong> {info.municipio}</p>}
                {info.orgao && <p className='mt-2'><strong>Órgão:</strong> {info.orgao}</p>}
                {info.modalidade && <p className='mt-2'><strong>Modalidade:</strong> {info.modalidade}</p>}
                {info.tipo_licitacao && <p className='mt-2'><strong>Tipo de Licitação:</strong> {info.tipo_licitacao}</p>}
                {info.dsc_document && <p className='mt-2'><strong>Descrição do Documento:</strong> {info.dsc_document}</p>}
                {info.num_processo && <p className='mt-2'><strong>Número do processo:</strong> {info.num_processo}</p>}
                {info.num_modalidade && <p className='mt-2'><strong>Número da modalidade:</strong> {info.num_modalidade}</p>}
                {info.nome_vencedor && <p className='mt-2'><strong>Fornecedor:</strong> {info.nome_vencedor}</p>}
                {info.cnpj_vencedor && (
                    <p className='mt-2'><strong>CNPJ do vencedor:</strong> {info.cnpj_vencedor.length === 14
                        ? <Link href={`${process.env.REACT_APP_CNPJ_URL}${info.cnpj_vencedor}`} target='_blank'>{info.cnpj_vencedor}</Link>
                        : info.cnpj_vencedor}
                    </p>
                )}
                <Divider sx={{ my: 2 }} />
                <Typography variant="h4" textAlign='center' color="initial" sx={{ mb: 2 }}>Item</Typography>
                {info.cp_original && <p className='mt-2'><strong>Descrição Compra Pública:</strong> {info.cp_original}</p>}
                {info.rf_original_dsc && <p className='mt-2'><strong>Descrição Referência:</strong> {info.rf_original_dsc}</p>}
                {info.cp_fonte && <p className='mt-2'><strong>Fonte Compra Pública:</strong> {info.cp_fonte}</p>}
                {info.rf_fonte && <p className='mt-2'><strong>Fonte Referência:</strong> {info.rf_fonte}</p>}
                {info.flag_produto_servico && <p className='mt-2'><strong>Srv / Prd:</strong>  {info.flag_produto_servico}</p>}
                {info.qtde_item && <p className='mt-2'><strong>Quantidade:</strong> {info.qtde_item}</p>}
                {info.dsc_unidade_medida && <p className='mt-2'><strong>Unid. Medida:</strong> {info.dsc_unidade_medida}</p>}
                {info.cp_preco && <p className='mt-2'><strong>Preço Compra Pública (R$):</strong>  {info.cp_preco}</p>}
                {info.rf_preco && <p className='mt-2'><strong>Preço Referência (R$):</strong>  {info.rf_preco}</p>}
                {info.diff_preco && <p className='mt-2'><strong>Diferença (R$):</strong>  {info.diff_preco}</p>}
                {info.diff_preco_percent && <p className='mt-2'><strong>Percentual de Diferença (%):</strong> {info.diff_preco_percent.toFixed(2)}%</p>}
                {info.palavras && <p className='mt-2'><strong>Descrição Processada:</strong> {info.palavras}</p>}
            </Box>
        </div>
    );

    return (
        <>
            <style>{`
                @media print {
                    .print-content {
                        display: block;
                    }
                    .dialog-content {
                        display: none;
                    }
                }
                @media screen {
                    .print-content {
                        display: none;
                    }
                }
            `}</style>

            {open && renderPrintContent()}
            <Dialog open={open} onClose={onClose} aria-describedby="alert-dialog-slide-description" maxWidth='sm' fullWidth>
                <DialogTitle color='white' sx={{ bgcolor: '#00617b', backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
                    <div className="flex flex-row">
                        <div className="basis-10/12">
                            <Typography variant="h4" color="white" textAlign='center'>
                                {primeiraLetraMaiuscula(info?.cp_fonte?.toLowerCase())}
                            </Typography>
                        </div>
                        <div className="basis-1/12">
                            <Button variant="contained" onClick={handlePrint} color='inherit' sx={{ color: '#00617b' }} startIcon={<Print />}>Imprimir</Button>
                        </div>
                        <div className="basis-1/12">
                            <IconButton
                                aria-label="close"
                                onClick={onClose}
                                sx={{
                                    position: 'absolute',
                                    right: 15,
                                    top: 15,
                                }}
                            >
                                <Close sx={{ color: "white" }} />
                            </IconButton>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent className="dialog-content">
                    {info.id_licitacao && (
                        <p><strong>Id documento:</strong> {info.id_licitacao?.substr(0, 1) === 'M' || info.id_licitacao?.substr(0, 1) === 'E'
                            ? <Link href={`${process.env.REACT_APP_TRILHAS_LICITACOES_URL}/licitacao/${info.id_licitacao}`} target='_blank'>{info.id_licitacao}</Link>
                            : info.id_licitacao}
                        </p>
                    )}
                    {info.periodo && <p className='mt-2'><strong>Período:</strong> {info.periodo}</p>}
                    {info.municipio && <p className='mt-2'><strong>Município:</strong> {info.municipio}</p>}
                    {info.orgao && <p className='mt-2'><strong>Órgão:</strong> {info.orgao}</p>}
                    {info.modalidade && <p className='mt-2'><strong>Modalidade:</strong> {info.modalidade}</p>}
                    {info.tipo_licitacao && <p className='mt-2'><strong>Tipo de Licitação:</strong> {info.tipo_licitacao}</p>}
                    {info.dsc_document && <p className='mt-2'><strong>Descrição do Documento:</strong> {info.dsc_document}</p>}
                    {info.num_processo && <p className='mt-2'><strong>Número do processo:</strong> {info.num_processo}</p>}
                    {info.num_modalidade && <p className='mt-2'><strong>Número da modalidade:</strong> {info.num_modalidade}</p>}
                    {info.nome_vencedor && <p className='mt-2'><strong>Fornecedor:</strong> {info.nome_vencedor}</p>}
                    {info.cnpj_vencedor && (
                        <p className='mt-2'><strong>CNPJ do vencedor:</strong> {info.cnpj_vencedor.length === 14
                            ? <Link href={`${process.env.REACT_APP_CNPJ_URL}${info.cnpj_vencedor}`} target='_blank'>{info.cnpj_vencedor}</Link>
                            : info.cnpj_vencedor}
                        </p>
                    )}
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h4" textAlign='center' color="initial" sx={{ mb: 2 }}>Item</Typography>
                    {info.cp_original && <p className='mt-2'><strong>Descrição Compra Pública:</strong> {info.cp_original}</p>}
                    {info.rf_original_dsc && <p className='mt-2'><strong>Descrição Referência:</strong> {info.rf_original_dsc}</p>}
                    {info.cp_fonte && <p className='mt-2'><strong>Fonte Compra Pública:</strong> {info.cp_fonte}</p>}
                    {info.rf_fonte && <p className='mt-2'><strong>Fonte Referência:</strong> {info.rf_fonte}</p>}
                    {info.flag_produto_servico && <p className='mt-2'><strong>Srv / Prd:</strong> {info.flag_produto_servico}</p>}
                    {info.qtde_item && <p className='mt-2'><strong>Quantidade:</strong> {info.qtde_item}</p>}
                    {info.dsc_unidade_medida && <p className='mt-2'><strong>Unid. Medida:</strong> {info.dsc_unidade_medida}</p>}
                    {info.cp_preco && <p className='mt-2'><strong>Preço Compra Pública (R$):</strong> {info.cp_preco}</p>}
                    {info.rf_preco && <p className='mt-2'><strong>Preço Referência (R$):</strong> {info.rf_preco}</p>}
                    {info.diff_preco && <p className='mt-2'><strong>Diferença (R$):</strong> {info.diff_preco}</p>}
                    {info.diff_preco_percent && <p className='mt-2'><strong>Percentual de Diferença (%):</strong> {info.diff_preco_percent.toFixed(2)}%</p>}
                    {info.palavras && <p className='mt-2'><strong>Descrição Processada:</strong> {info.palavras}</p>}
                </DialogContent>
            </Dialog>
        </>
    );
}

export default InfoOverpriceDialog;

